import React from "react";
import ReactStars from 'react-stars';

export default (props) => (
    <div className="name-and-rating">
        <div className="name">{props.last_name + " " + props.first_name}</div>
        <div className="rating">
            <div className="like text_green">+ {props.like_count}</div>
            <pre> / </pre>
            <div className="dislike text_red">- {props.dislike_count}</div>

            <div className="rating-container" title="Рейтинг пользователя">
                <ReactStars
                    count={5}
                    size={20}
                    value={props.summary_rating}
                    edit={false}
                    color2={'#ffd700'} />
            </div>
            
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/Profile/Commons/NameAndRating.js